import { create } from "zustand";

import axios from 'axios';
import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';
import { notification } from "antd";
import { baseURL, baseURLWithoutApi } from "../../baseUrl";

export const useSubscriptions = create((set, get) => ({
    loader: false,
    subscriptions: [],
    userInit: null,
    isFetch: false,
    hasMore: true,
    showServerError: false,
    userAllSubs: [],
    subsSum: 0,
    subscriptionPagination: {},
    actions: {
        editSubscription: async (id, userId, startDate, endDate, months, description, type, isActive, isPaid, userSubscriptionDetailViewModels, days, maxDevices) => {
            // set((state) => ({ loader:  true }))
            await axios.patch(`https://api.pelakeman.com/api/UserSubscription/EditSubscription`, {
                "id": id,
                "userId": userId,
                "startDate": startDate,
                "endDate": endDate,
                "months": months,
                "days": days,
                "description": description,
                "type": type,
                "isActive": isActive,
                "isPaid": isPaid,
                "maxDevices": maxDevices,
                "userSubscriptionDetailViewModels": userSubscriptionDetailViewModels
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    if (res.status == 200) {
                        // set((state) => ({ loader: false }))
                        notification.open({
                            icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                            </svg >,
                            message: 'عملیات موفق',
                            description:
                                'اشتراک کاربر با موفقیت تغییر کرد',
                        })
                    } else {
                        notification.open({
                            icon: <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                            </svg >,
                            message: 'خطا',
                            description:
                                'ویرایش اشتراک اطلاعات کاربر با خطا مواجه شد',
                        })
                    }
                }).catch(() => {
                    set((state) => ({ showServerError: true }))
                })
        },


        clearUserInit: async (userId) => {
            set((state) => ({ userInit: null }))
        },
        getUserInit: async (userId) => {
            set((state) => ({ isFetch: true }))
            await axios.get(`https://api.pelakeman.com/api/User/UserInit?UserId=${userId}`, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    // console.log(res.data?.subscriptionMains, 11111111111111);

                    set((state) => ({ isFetch: false }))
                    set((state) => ({ userInit: res?.data }))
                    set((state) => ({ userAllSubs: res?.data?.subscriptionMains }))
                }).catch(() => {
                    set((state) => ({ isFetch: false }))
                    set((state) => ({ showServerError: true }))
                })
        },

        getAllUserSubscriptionContoller: async (
            searchQuery,
            startDateFrom,
            startDateTo,
            endDateFrom,
            endDateTo,
            isActive,
            isPaid,
            priceFrom,
            priceTo,
            lastId,
            isClearPrevState,
            page,
            state,
            city,
            areas,
            orderBy = "ID"
        ) => {
            set((state) => ({ loader: true }))
            await axios.post(`https://api.pelakeman.com/api/UserSubscription/GetAll`, {
                "searchQuery": searchQuery,
                "startDateFrom": startDateFrom,
                "startDateTo": startDateTo,
                "endDateFrom": endDateFrom,
                "endDateTo": endDateTo,
                "isActive": isActive,
                "isPaid": isPaid,
                "priceFrom": priceFrom,
                "priceTo": priceTo,
                "lastId": lastId,
                "page": page,
                "state": state,
                "city": city,
                "area": areas,
                "orderBy": orderBy
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    if (isClearPrevState) {
                        set((state) => ({ subscriptions: res.data.result }))
                        set((state) => ({ subscriptionPagination: res.data.pagination }))
                    } else {
                        if (res.data.length) {
                            set((state) => ({ subscriptions: [...state.subscriptions, ...res.data.result] }));
                        } else {
                            set((state) => ({ hasMore: false }))
                        }
                    }
                    set((state) => ({ loader: false }))
                }).catch(() => {
                    set((state) => ({ loader: false }))
                    set((state) => ({ showServerError: true }))
                })
        },
        getSubscriptionsSum: async (startDate, endDate, cityId) => {
            set((state) => ({ loader: true }))
            await axios.post(`https://api.pelakeman.com/api/UserSubscription/GetSubscriptionsSum`, {
                "startDate": startDate,
                "endDate": endDate,
                "cityId": cityId,
            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {

                    set((state) => ({ subsSum: res?.data?.result }))
                }).catch(() => {
                    set((state) => ({ loader: false }))
                    set((state) => ({ showServerError: true }))
                })
        },

        clearSubscriptionList: async () => {
            set((state) => ({ subscriptions: [] }))
        },



    }
}))

// export const todosGet = useGetTodos.setState